module.exports = __webpack_public_path__ + "img/overtime.26190e19.png";